import { invariant, isPrimitive } from '../utils/utils';
import { getModelSchema } from '../api/getDefaultModelSchema';
import { _defaultPrimitiveProp, SKIP } from '../constants';
import { SerializeObjectContext } from '../context/SerializeObjectContext';
import { SerializeAttributeContext } from '../context/SerializeAttributeContext';
export function serialize(thing, defaultSchema = undefined) {
    let schema = defaultSchema;
    if (!schema) {
        if (Array.isArray(thing)) {
            if (thing.length === 0) {
                return [];
            }
            schema = getModelSchema(thing[0]);
        }
        else if (!schema) {
            schema = getModelSchema(thing);
        }
    }
    if (schema) {
        if (Array.isArray(thing)) {
            return thing.map(item => serializeWithSchema(schema, item));
        }
        return serializeWithSchema(schema, thing);
    }
    if (isPrimitive(thing)) {
        return thing;
    }
    if (Array.isArray(thing)) {
        return thing;
    }
    invariant(!!schema, `Failed to find default schema for ${thing}`);
}
export function serializeWithSchema(schema, target) {
    invariant(schema && typeof schema === 'object', 'Expected schema');
    invariant(target && typeof target === 'object', 'Expected object');
    let res;
    if (schema.extends) {
        res = serializeWithSchema(schema.extends, target);
    }
    else {
        res = {};
    }
    const objectContext = new SerializeObjectContext({ target });
    Object.keys(schema.props).forEach(propName => serializePropWithSchema(objectContext, schema, target, propName, res));
    return res;
}
export function serializePropWithSchema(objectContext, schema, target, propName, res) {
    let propDef = schema.props[propName];
    if (propDef === true)
        propDef = _defaultPrimitiveProp;
    if (propDef === false)
        return;
    const attrName = propDef.jsonname || propName;
    const context = new SerializeAttributeContext({ objectContext, attrName, propName });
    const jsonValue = propDef.serializer(context);
    if (jsonValue === undefined || jsonValue === SKIP) {
        return;
    }
    res[attrName] = jsonValue;
}
